(() => {
  const root = document.querySelector('[data-shir7-story]');
  if (!root) return;

  const STORAGE_KEY = 'shir7_floating_story_closed';
  if (sessionStorage.getItem(STORAGE_KEY) === '1') return;

  const preview = root.querySelector('[data-shir7-story-preview]');
  const openBtn = root.querySelector('[data-shir7-story-open]');
  const closeBtn = root.querySelector('[data-shir7-story-close]');
  const modal = document.querySelector('[data-shir7-story-modal]');
  const modalVideo = modal?.querySelector('[data-shir7-story-modal-video]');
  const modalClosers = modal?.querySelectorAll('[data-shir7-story-modal-close]');

  root.hidden = false;

  const tryPlayPreview = () => {
    if (!preview) return;
    preview.muted = true;
    const playPromise = preview.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  // Carrega/reproduz só quando a bolinha entra na tela
  if ('IntersectionObserver' in window && preview) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            tryPlayPreview();
          } else {
            preview.pause();
          }
        });
      },
      { threshold: 0.2 }
    );
    io.observe(root);
  } else {
    tryPlayPreview();
  }

  const openModal = () => {
    if (!modal || !modalVideo) return;
    preview?.pause();
    modal.hidden = false;
    document.documentElement.classList.add('overflow-hidden');
    modalVideo.muted = false;
    modalVideo.volume = 1;
    modalVideo.currentTime = 0;
    // Garante que o source com áudio só comece a baixar no clique
    if (typeof modalVideo.load === 'function' && modalVideo.readyState === 0) {
      modalVideo.load();
    }
    const playPromise = modalVideo.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {});
    }
  };

  const closeModal = () => {
    if (!modal || !modalVideo) return;
    modal.hidden = true;
    modalVideo.pause();
    document.documentElement.classList.remove('overflow-hidden');
    tryPlayPreview();
  };

  const dismissBubble = () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
    closeModal();
    preview?.pause();
    root.hidden = true;
  };

  openBtn?.addEventListener('click', openModal);
  closeBtn?.addEventListener('click', (e) => {
    e.stopPropagation();
    dismissBubble();
  });
  modalClosers?.forEach((el) => el.addEventListener('click', closeModal));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
  });
})();
